import { Produit } from '../../habilitation/models/produit.model';

export class DeclarationDrBase {
    static jsonMap = {
        codeProduit: 'codeProduit',
        mention: 'mention',
        igp: 'igp',
        erreurs: { key: 'erreursList' }
    };

    codeProduit: string;
    mention: string;
    igp: boolean;
    erreurs: string[] = [];

    produit: Produit = new Produit();
}
